import React from "react";

const AdminScreen: React.FC = () => {
  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100%",
      padding: "40px 24px",
    }}>
      <div style={{
        background: "rgba(26, 39, 68, 0.6)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        border: "1px solid rgba(255, 255, 255, 0.08)",
        borderRadius: "16px",
        padding: "56px 64px",
        maxWidth: "520px",
        width: "100%",
        textAlign: "center",
      }}>
        <div style={{
          display: "inline-block",
          background: "rgba(242, 101, 34, 0.15)",
          border: "1px solid rgba(242, 101, 34, 0.4)",
          borderRadius: "20px",
          padding: "4px 16px",
          marginBottom: "24px",
          fontSize: "12px",
          fontWeight: 600,
          color: "#F26522",
          letterSpacing: "0.06em",
          textTransform: "uppercase",
        }}>
          In Development
        </div>

        <div style={{
          fontSize: "48px",
          marginBottom: "16px",
          opacity: 0.6,
        }}>
          ⚙
        </div>

        <h1 style={{
          fontSize: "28px",
          fontWeight: 700,
          color: "#ffffff",
          margin: "0 0 12px",
        }}>
          Administration
        </h1>

        <p style={{
          fontSize: "15px",
          color: "#ADADAD",
          margin: "0",
          lineHeight: 1.6,
        }}>
          User management, permissions, and system configuration
        </p>
      </div>
    </div>
  );
};

export default AdminScreen;
